/**
 * English translations for status enum values.
 * These are domain-wide labels that apply to batches, chemicals,
 * storage facilities, certifications, companies, etc.
 */
export const statusEn = {
  // Batch / workflow statuses
  approved: 'Approved',
  pending_approval: 'Pending Approval',
  rejected: 'Rejected',
  in_transit: 'In Transit',
  active: 'Active',
  expired: 'Expired',
  needs_retest: 'Needs Retest',
  invalid: 'Invalid',
  delivered: 'Delivered',

  // Generic / certification statuses
  pending: 'Pending',
  draft: 'Draft',
  submitted: 'Submitted',
  valid: 'Valid',
  expiring_soon: 'Expiring Soon',
  revoked: 'Revoked',

  // Company / user statuses
  enabled: 'Enabled',
  disabled: 'Disabled',
  verified: 'Verified',
  unverified: 'Unverified',
  locked: 'Locked',

  // Storage facility statuses
  operational: 'Operational',
  closed: 'Closed',
  under_maintenance: 'Under Maintenance',

  // Fallback
  unknown: 'Unknown',
} as const
